var map = {
	"./de/main.yml": 28,
	"./en/main.yml": 29,
	"./fr/main.yml": 30,
	"./hr/main.yml": 31,
	"./hu/main.yml": 32,
	"./it/main.yml": 33,
	"./oc/main.yml": 34
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;